const getters = {
  token: (state) => state.user.token,
  phone: (state) => state.user.phone,
  name: (state) => state.user.name,
  avatar: (state) => state.user.avatar,
  path: (state) => state.app.path,
};
export default getters;
